import {
  PrimaryButton as FabricPrimaryButton,
  IconButton as FabricIconButton,
  DefaultButton as FabricDefaultButton,
} from '@fluentui/react/lib/Button';
import { ChoiceGroup as FabricChoiceGroup } from '@fluentui/react/lib/ChoiceGroup';
import { Link as FabricLink } from '@fluentui/react/lib/Link';
import { SearchBox as FabricSearchBox } from '@fluentui/react/lib/SearchBox';
import { Dropdown as FabricDropdown } from '@fluentui/react/lib/Dropdown';
import { TextField as FabricTextField } from '@fluentui/react/lib/TextField';
import { Checkbox as FabricCheckbox } from '@fluentui/react/lib/Checkbox';
import { Toggle as FabricToggle } from '@fluentui/react/lib/Toggle';

import {
  withSignal,
  CommonEventParser,
  DropdownEventParser,
} from '@bingads-webui-react/hoc-with-signal';

export const PrimaryButton = withSignal(FabricPrimaryButton, {
  onClick: CommonEventParser,
});

export const DefaultButton = withSignal(FabricDefaultButton, {
  onClick: CommonEventParser,
});

export const ChoiceGroup = withSignal(FabricChoiceGroup, {
  onChange: CommonEventParser,
});

export const Link = withSignal(FabricLink, {
  onClick: CommonEventParser,
});

export const SearchBox = withSignal(FabricSearchBox, {
  onChange: CommonEventParser,
});

export const Dropdown = withSignal(FabricDropdown, {
  onChange: DropdownEventParser,
});

export const TextField = withSignal(FabricTextField, {
  onChange: CommonEventParser,
});

export const Checkbox = withSignal(FabricCheckbox, {
  onChange: CommonEventParser,
});

export const Toggle = withSignal(FabricToggle, {
  onChange: CommonEventParser,
});

export const IconButton = withSignal(FabricIconButton, {
  onClick: CommonEventParser,
});
